import { AppData, Img, Lightning, Utils } from "@lightningjs/sdk";
import { AppSetup } from "../../../app-setup";
import { Theme } from "../../../../ui-elements/info-ui";
import { Artwork, Icon } from "@lightningjs/ui-components";
import { Helper } from "../../../helper";

export default class ExpandableTileLandscape extends Lightning.Component<Lightning.Component.TemplateSpecLoose> {
    _theme: Theme = {};
    _imgSrc = ''
    _blockItem = false;
    static override _template() {
        return {
            Wrapper: {
                zIndex: 7,
                x: 0,
                y: 10,
                w: (w) => w,
                h: (h) => h,
                collision:true,
                zIndex:10,
                Artwork: {},
                BlockItem: {},
                Stroke: {
                    x: -13,
                    y: -13,
                    w: (w) => w + 26,
                    h: (h) => h + 26,
                    rect: true,
                    color: 0x000000,
                    shader: {
                        type: Lightning.shaders.RoundedRectangle,
                        radius: 10,
                        stroke: 7,
                        strokeColor: 0x00000000
                    }
                },
            },
            Numbering: {}
        }
    }

    set imgSrc(url: string) {
        this._imgSrc = url
        const w = this.isNumberRow ? (this.w - 180) : this.w
        if (this._imgSrc !== '') {
            this.tag('Wrapper').tag('Artwork').patch({
                x: w/2,
                y: this.h/2,
                mount: 0.5,
                w: w,
                h: this.h,
                src: url
            })
        } else {
            //this.tag('Wrapper').patch({Artwork: {}})
        }
    }

    get imgSrc() {
        return this._imgSrc
    }

    set blockItem(value: boolean) {
        this._blockItem = value;
        //console.log(this._blockItem);
        this.updateBlockItem();
    }

    updateBlockItem() {
        const w = this.isNumberRow ? (this.w - 180) : this.w
        if (this._blockItem) {
            this.tag('Wrapper').patch({
                BlockItem: {
                    w: w,
                    h: this.h,
                    rect: true,
                    color: 0xAA222222,
                    Icon: {
                        x: w-10,
                        mountX: 1,
                        type: Icon,
                        y: 10,
                        w: 50,
                        h: 50,
                        icon: Utils.asset('/svg/ico-block.svg'),
                    }
                }
            })
        } else {
            this.tag('BlockItem').patch({})
        }
    }

    override _focus() {
        this.tag('Stroke').shader.strokeColor = this.isNumberRow ? null : this._theme.gridfocuscolor;
        if(this.isNumberRow){
            this.tag('Wrapper').smooth = { scale : 1.15 }
            this.tag('Numbering').patch({  alpha: 1 })
        }
        this.fireAncestors('$vodItemChanged');
    }

    override _unfocus() {
        this.tag('Stroke').shader.strokeColor = 0x00000000
        if(this.isNumberRow){
            this.tag('Wrapper').smooth = { scale : 1 }
            this.tag('Numbering').patch({  alpha: 0.8 })
        }
    }

    override _init() {
        const { appState, appConfig } = AppData as AppSetup
        const app = appState?.getApp();
        this._theme = (app?.themesObj as Theme) || {};
        const appApiConfig = appState?.getAppApiConfig()
        this._theme.gridfocuscolor = `0xff${appApiConfig?.appLayoutConfig?.gridfocuscolor}` || '0xffffffff'
        if(this.isNumberRow) {
            this.tag('Wrapper').patch({
                x: this.itemIndex === 9 ? 280 : 140,
                w: this.w - 150
            })
            this.patch({
                Numbering: {
                alpha: 0.8,
                zIndex: 10,
                text: { 
                    text: this.itemIndex + 1,
                    fontFace: Helper.getFontFamily('Black'),
                    fontSize: 280,
                    offsetY: 240,
                    letterSpacing: -10
                }
            }
            })
        }
    }

    _handleClick(target) {
        console.log('Thumbnail Click: ', this)
        this.fireAncestors('$GridThumbClick', this)
        return false
    }

}
